export const minDateStr = '2000-01-01';
export const maxDateStr = '2099-12-31';
export const maxNoteLength = 128;

export function firstOfCurrentMonth() {
  const date = new Date();
  return new Date(date.getFullYear(), date.getMonth(), 1).toLocaleDateString();
}

export function currentDate() {
  return new Date().toLocaleDateString();
}
